import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Hand, CheckCircle2, Undo2, Trash2, Plus } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { fmtDT } from "@/lib/qr";
import { useAuth } from "@/context/AuthContext";

function Task({ t, me, main, reload }) {
  const act = async (a) => { try { await api.post(`/admin/tasks/${t.id}/${a}`); if (a === "done") toast.success("Detyra u krye"); } catch (e) { toast.error(errMsg(e)); } reload(); };
  const mine = t.worker_id === me;
  return (
    <div className={`rounded-2xl p-3 border-2 ${t.status === "working" ? (mine ? "bg-emerald-50 border-emerald-300" : "bg-amber-50 border-amber-300") : "bg-white border-slate-200"}`} data-testid={`task-${t.id}`}>
      <div className="text-sm font-semibold text-slate-900 whitespace-pre-wrap break-words">{t.text}</div>
      <div className="text-[11px] text-slate-400 mt-0.5" translate="no">Shkroi {t.created_by_name} · {fmtDT(t.created_at)}</div>
      {t.status === "working" && <div className="mt-1.5 text-xs font-bold text-amber-700" data-testid={`task-worker-${t.id}`} translate="no">Po punon: {mine ? "Ti" : t.worker_name}</div>}
      <div className="flex gap-2 mt-2">
        {t.status === "open" && <button data-testid={`task-claim-${t.id}`} onClick={() => act("claim")} className="flex-1 h-11 rounded-xl bg-blue-600 text-white text-sm font-bold flex items-center justify-center gap-1.5"><Hand className="w-4 h-4" />Po punoj unë</button>}
        {t.status === "working" && (mine || main) && <button data-testid={`task-done-${t.id}`} onClick={() => act("done")} className="flex-1 h-11 rounded-xl bg-emerald-500 text-white text-sm font-bold flex items-center justify-center gap-1.5"><CheckCircle2 className="w-4 h-4" />E kreva</button>}
        {t.status === "working" && (mine || main) && <button data-testid={`task-release-${t.id}`} onClick={() => act("release")} className="h-11 px-3 rounded-xl bg-white border border-slate-200 text-slate-600 text-xs font-semibold flex items-center gap-1"><Undo2 className="w-4 h-4" />Lëshoje</button>}
        {(t.created_by === me || main) && <button data-testid={`task-del-${t.id}`} onClick={() => act("delete")} className="h-11 px-3 rounded-xl bg-rose-50 text-rose-500"><Trash2 className="w-4 h-4" /></button>}
      </div>
    </div>
  );
}

export default function AdminTasks() {
  const { user } = useAuth();
  const [list, setList] = useState([]);
  const [text, setText] = useState("");
  const load = () => api.get("/admin/tasks").then((r) => setList(r.data)).catch(() => {});
  useEffect(() => { load(); const i = setInterval(load, 15000); return () => clearInterval(i); }, []);
  const add = async () => {
    if (!text.trim()) return;
    try { await api.post("/admin/tasks", { text }); setText(""); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-2" data-testid="admin-tasks">
      <div className="bg-white rounded-2xl p-3 border border-slate-200 space-y-2">
        <div className="text-sm font-bold text-slate-900">Çfarë kemi për të punuar?</div>
        <textarea data-testid="task-input" value={text} onChange={(e) => setText(e.target.value)} rows={2} placeholder="Shkruaj detyrën ose projektin..." className="w-full rounded-xl border border-slate-200 p-3 text-sm" />
        <button data-testid="task-add" onClick={add} className="w-full h-11 rounded-xl bg-slate-900 text-white text-sm font-bold flex items-center justify-center gap-1.5"><Plus className="w-4 h-4" />Shto në listë</button>
      </div>
      {list.map((t) => <Task key={t.id} t={t} me={user?.id} main={user?.role === "admin"} reload={load} />)}
      {!list.length && <p className="text-center text-sm text-slate-400 py-4" data-testid="tasks-empty">Asnjë detyrë e hapur.</p>}
    </div>
  );
}
